import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, Notice } from "@/components/Badges";

const NiceFinder = () => {
  const [q, setQ] = useState("");
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/ip/nice-classes", { params: { q } }).then(({ data }) => setD(data));
  }, [q]);
  return (
    <section className="card p-6" data-testid="nice-class-finder">
      <h2 className="font-semibold text-[#0B192C]">Trade mark class finder</h2>
      <input aria-label="Filter classes" data-testid="nice-filter-input" className="input mt-3" placeholder="e.g. software, clothing, education" value={q} onChange={(e) => setQ(e.target.value)} />
      <ul className="mt-3 grid max-h-72 gap-1 overflow-auto text-sm sm:grid-cols-2">
        {d?.classes.map((c) => <li key={c.class}><span className="font-mono text-xs text-[#0D9488]">Class {c.class}</span> {c.heading} <span className="caption">{c.type}</span></li>)}
      </ul>
      <p className="mt-3 text-xs text-slate-500">{d?.note}</p>
    </section>
  );
};

export default function IPSearch() {
  const [q, setQ] = useState("");
  const [kind, setKind] = useState("patent");
  const [res, setRes] = useState(null);
  const run = async (e) => {
    e.preventDefault();
    const { data } = await api.get("/ip/search-sources", { params: { q, kind } });
    setRes(data);
  };
  return (
    <div className="space-y-6 fade-up">
      <PageHeader title="Preliminary IP search tools" sub="Search official databases directly. Results are preliminary and are not confirmation of patentability, clearance or freedom to operate." />
      <form onSubmit={run} className="card grid gap-3 p-5 sm:grid-cols-4" data-testid="ip-search-form">
        <select aria-label="Search type" data-testid="ip-search-kind" className="input" value={kind} onChange={(e) => setKind(e.target.value)}><option value="patent">Patents / prior art</option><option value="trade_mark">Trade marks</option><option value="design">Registered designs</option></select>
        <input aria-label="Search terms" data-testid="ip-search-input" className="input sm:col-span-2" placeholder="Keywords - avoid confidential detail" value={q} onChange={(e) => setQ(e.target.value)} />
        <button data-testid="ip-search-submit" className="btn-teal">Prepare searches</button>
      </form>
      {res && (
        <section className="space-y-3" data-testid="ip-search-results">
          {res.sources.map((s) => (
            <a key={s.name} href={s.url} target="_blank" rel="noreferrer" className="card flex items-center justify-between gap-4 p-5 hover:border-[#0D9488]">
              <div><p className="font-semibold text-[#0B192C]">{s.name}</p><p className="text-xs text-slate-500">Scope: {s.scope} · {s.official ? "Official source" : "Licensed source"}</p></div>
              <ExternalLink className="h-4 w-4 shrink-0 text-[#0D9488]" />
            </a>
          ))}
          <Notice tone="warn" testid="ip-search-limitations">{res.limitations}</Notice>
        </section>
      )}
      <NiceFinder />
    </div>
  );
}
